export const LABELS = {
    CREATE_INSIGHT_DECK: "Compile insight deck",
    GENERATE_EMAIL: "Generate e-mail",
    INSIGHT_DECK: "Insight deck",
    INSIGHT: "Insight",
    WHOOPS_SOMETHING_WENT_WRONG: "Whoops, something went wrong.",
    REFRESH_OR_TRY_AGAIN_LATER: "Please refresh the page or try again later",
    SORT_BY: "Sort by",
};

export const COPY_MESSAGES = {
    MARKETING: "URL copied for sharing marketing content",
    INSIGHT: "URL copied for sharing insight",
    TEMPLATE: "URL copied for sharing template",
    DEFAULT: "URL copied for sharing",
} as const;

export const TOOLTIP_MESSAGES = {
    MARKETING: "Share this marketing content with others",
    INSIGHT: "Share this insight with others",
    DEFAULT: "Share this content with others",
} as const;

export const FALLBACK_VALUE = {
    INVALID_DATE_LABEL: "-",
};
